import React from 'react';
import { BwLogoGlyph } from './icons';
import { ServetWordmark } from './ServetWordmark';

const LINKS = [
  { href: '#evidence', label: 'Evidence' },
  { href: '#scoring', label: 'Scoring' },
  { href: '#workflow', label: 'How it works' },
  { href: '#product', label: 'Product' },
];

/** Landing-specific footer with the SerVet "A PRODUCT OF" lockup. */
export function LandingFooter() {
  return (
    <footer className="bg-bw-sidebar text-white/60">
      <div className="max-w-[1180px] mx-auto px-5 sm:px-8 py-12 flex flex-wrap gap-7 items-center justify-between">
        {/* Brand + SerVet lockup */}
        <div className="flex items-center gap-4">
          <span className="flex items-center gap-2.5">
            <span className="w-[30px] h-[30px] rounded-lg bg-bw-primary text-white flex items-center justify-center">
              <BwLogoGlyph className="w-[15px] h-[15px]" />
            </span>
            <span className="text-base font-extrabold text-white tracking-tight">BidWin</span>
          </span>
          <span className="w-px h-[26px] bg-white/20 inline-block" />
          <span className="flex flex-col gap-1.5">
            <span className="font-mono text-[9.5px] font-medium tracking-[0.1em] text-white/45">
              A PRODUCT OF
            </span>
            <span className="bg-white rounded-md px-2.5 py-1.5 inline-flex items-center">
              <ServetWordmark variant="onWhiteChip" />
            </span>
          </span>
        </div>

        {/* Anchor links */}
        <div className="flex flex-wrap gap-6">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[13.5px] text-white/60 hover:text-white transition-colors no-underline"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="font-mono text-[11.5px] text-white/40">© 2026 SerVet Digital LLC</div>
      </div>
    </footer>
  );
}
